import { Eyebrow } from '../brand';
import { useLang } from '../lang';

export function Legal({ kind }: { kind: 'privacy' | 'terms' }) {
  const { t } = useLang();
  return (
    <section className="band legal" id="top" aria-labelledby="legal-title">
      <div className="frame legal-grid">
        <header data-reveal>
          <Eyebrow k={`${kind}.eyebrow`} />
          <h1 id="legal-title" className="display">
            {t(`${kind}.title`)}
          </h1>
          <p className="legal-note">{t('legal.updated')}</p>
        </header>
        <div className="legal-copy">
          {[1, 2, 3, 4, 5].map((n) => (
            <p key={n} data-reveal>
              {t(`${kind}.p${n}`)}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}
